import React from 'react';
import * as _ from 'lodash';
// import { SchaduleBar } from '../../components/gagebar/bar';
import Tippy from '../ReactTippy';
import {
  APPROVED_STATUS,
  PRIVATE_PARTNER_COMPANY_LABEL,
} from '../../utilities/constants';
// import { APPROVED_STATUS, USER_ROLES } from '../../utilities/constants';
// import { isTargetRoleId } from '../../utilities/roleUtility';
import SessionStorageService from '../../services/utilities/SessionStorageService';

/**
 * 「揚重機予定」のテーブル
 *
 * @param {*} {
 *   crane,
 *   selectedGroup,
 *   isSelected,
 *   dialogs,
 *   callbacks,
 *   isConferenceMode,
 * }
 */
export const CraneUsesContents = ({
  crane,
  selectedGroup,
  isSelected,
  dialogs,
  callbacks,
  isConferenceMode,
  userRollId,
  scheduleLimitTimes,
  disabledTimes,
  viewOnlyFlag,
  isTimeBarReset,
  onToggleApprovalSingle,
}) => (
  <tbody id={`group-${crane.id}`} className='table__group show'>
    <tr
      className='table-section-header'
      style={{ borderTop: '1px solid #7C7C7C' }}
    >
      {!isConferenceMode && (
        <td className='data-table__cell'>
          <div className='value-table__icon'>
            <div className='btn-checkbox'>
              <label htmlFor={`btn-checkbox-group-${crane.id}-all`}>
                <input
                  id={`btn-checkbox-group-${crane.id}-all`}
                  className=''
                  type='checkbox'
                  checked={selectedGroup || false}
                  onChange={() =>
                    callbacks.handleSelectedGroup(!selectedGroup, crane.id)
                  }
                />
                <i className='i-square i-3x' />
              </label>
            </div>
          </div>
        </td>
      )}
      <td colSpan='8' style={{ padding: '0', boxSizing: 'content-box' }}>
        <div
          className='table-section-header__title'
          style={{
            padding: isConferenceMode ? '0 20px' : '4px 0',
          }}
        >
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={renderTooltipContent(crane.name)}
          >
            <span className='table-section-header__content'>{crane.name}</span>
          </Tippy>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={renderTooltipContent(crane.spec_form)}
          >
            <span
              className='table-section-header__content'
              style={{ margin: '0 8px' }}
            >
              性能：{crane.spec_form}
            </span>
          </Tippy>

          <Operator crane={crane} dialogs={dialogs} />
          <span className='btn-menu__items sm--hidden'>
            <button
              id='modal-open-document'
              className='btn--sm--sub'
              onClick={() =>
                dialogs.handleVisible('documents', undefined, crane.id)
              }
            >
              印刷
            </button>
          </span>
        </div>
      </td>
    </tr>
    {_.map(crane.craneUses, craneUse => (
      <CraneUse
        key={craneUse.id}
        craneId={crane.id}
        data={craneUse}
        selected={isSelected(crane.id, craneUse.id)}
        handleSelectedRow={callbacks.handleSelectedRow}
        handleEdit={callbacks.edit}
        handleGageUpdate={callbacks.handleGageUpdate}
        isConferenceMode={isConferenceMode}
        userRollId={userRollId}
        scheduleLimitTimes={scheduleLimitTimes}
        disabledTimes={disabledTimes}
        viewOnlyFlag={viewOnlyFlag}
        isTimeBarReset={isTimeBarReset}
        onToggleApprovalSingle={onToggleApprovalSingle}
      />
    ))}
    <tr
      className='see-more'
      style={
        crane.craneUseLoaded ? { display: 'none' } : { display: 'table-row' }
      }
    >
      <td colSpan='8'>
        <button
          className='see-more__button see-more__button__blue'
          onClick={() => callbacks.handleSeeMore(crane.id)}
        >
          <i className='see-more__button__icon' />
          <p className='see-more__button__text'>さらに表示する</p>
        </button>
      </td>
    </tr>
  </tbody>
);

/**
 * 揚重機予定一覧に表示される作成後の「オペレータ」
 *
 * @param {*} { crane, dialogs }
 * @returns
 */
const Operator = ({ crane, dialogs }) => {
  const dateFrom = SessionStorageService.getItem('date_from');
  const dateTo = SessionStorageService.getItem('date_to');
  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 20,
    },
    buttonTxt: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      marginRight: 10,
      padding: 0,
      maxWidth: 240,
    },
    buttonTxtMini: {
      display: 'flex',
      alignItems: 'center',
      border: 'none',
      padding: 0,
      color: '#E64E17',
      fontSize: 12,
      lineHeight: '1.5',
      textDecoration: 'underline',
    },
    tooltip: {
      maxWidth: 360,
      color: '#fff',
      textAlign: 'left',
      wordBreak: 'break-all',
    },
  };

  if (dateFrom !== dateTo) {
    return <div />;
  }

  if (_.isEmpty(crane.crane_operator_schedules)) {
    // オペレータをまだ設定してない時
    return (
      <button
        id='modal-open-operator'
        className='btn-text--sm'
        onClick={() => dialogs.handleOperatorVisible(crane.id)}
        style={{ height: 24 }}
      >
        オペレータを設定
      </button>
    );
  } else {
    // オペレータを設定した後
    return (
      <div style={styles.container}>
        {/* オペレータ編集ダイアログをクリックで開く */}
        <Tippy
          delay={[500, 0]}
          duration={10}
          distance={24}
          placement='bottom'
          followCursor={true}
          html={
            <div style={styles.tooltip}>
              <span style={{ whiteSpace: 'pre', color: 'white' }}>
                {crane.crane_operator_schedules[0].operator_name}
              </span>
            </div>
          }
        >
          <button
            className='btn-text--normal'
            onClick={() =>
              dialogs.handleUpdateOperatorVisible(
                crane.id,
                crane.crane_operator_schedules[0]
              )
            }
            style={styles.buttonTxt}
          >
            <span className='overflow-text' style={{ whiteSpace: 'pre' }}>
              {crane.crane_operator_schedules[0].operator_name}
            </span>
          </button>
        </Tippy>
        <button
          id='modal-open-operator'
          className='btn-text--mini'
          onClick={() =>
            dialogs.handleDelete(crane.crane_operator_schedules[0].id)
          }
          style={styles.buttonTxtMini}
        >
          解除
        </button>
      </div>
    );
  }
};

const renderCompanyName = data => {
  if (!data.spot_company_flag) {
    let betto_label = '';
    if (data.private_partner_company_flag === 1) {
      betto_label = PRIVATE_PARTNER_COMPANY_LABEL;
    }
    switch (data.nest_no) {
      case 1:
        return (
          <React.Fragment>
            {data.company_name_1}{betto_label}
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_2}){betto_label}
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_3}){betto_label}
          </React.Fragment>
        );
      case 4:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_4}){betto_label}
          </React.Fragment>
        );
      case 5:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_5}){betto_label}
          </React.Fragment>
        );
      default:
        return data.company_name;
    }
  } else {
    return `${data.spot_company_name}`;
  }
};

const renderCompanyNameTableCell = data => {
  if (!data.spot_company_flag) {
    let betto_label = '';
    if (data.private_partner_company_flag === 1) {
      betto_label = PRIVATE_PARTNER_COMPANY_LABEL;
    }
    switch (data.nest_no) {
      case 1:
        return (
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.company_name_1}{betto_label}
          </span>
        );
      case 2:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_2}){betto_label}
            </span>
          </div>
        );
      case 3:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_3}){betto_label}
            </span>
          </div>
        );
      case 4:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_4}){betto_label}
            </span>
          </div>
        );
      case 5:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_5}){betto_label}
            </span>
          </div>
        );
      default:
        return (
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.company_name}
          </span>
        );
    }
  } else {
    return (
      <span className='data-table__text-wrap data-table__text-wrap--overflow'>
        {data.spot_company_name}
      </span>
    );
  }
};

const CraneUse = ({
  data,
  craneId,
  handleSelectedRow,
  handleEdit,
  isConferenceMode,
  selected,
  onToggleApprovalSingle,
}) => (
  <tr
    className='data-table__item data-table__item--clickable'
    onMouseUp={e => handleEdit(e, data)}
  >
    {!isConferenceMode && (
      <React.Fragment>
        <td className='data-table__cell' data-unlink>
          <div className='btn-checkbox'>
            <label htmlFor={`btn-checkbox-group-${data.id}`}>
              <input
                id={`btn-checkbox-group-${data.id}`}
                className='sys-btn-checkbox'
                type='checkbox'
                value={data.id}
                checked={selected}
                onClick={e => handleSelectedRow(e, craneId, !selected)}
              />
              <i className='i-square i-3x' />
            </label>
          </div>
        </td>
        {/* 日付 */}
        <td className='data-table__cell data-table__cell--minimum' data-unlink>
          <div className='data-table__content'>{data.use_date.slice(5)}</div>
        </td>
        {/* ステータス */}
        <td className='data-table__cell data-table__cell--minimum' data-unlink>
          <button
            className={
              data.approval_flag
                ? 'status-ticket--large conf-status-ticket'
                : 'status-ticket--caution--large conf-status-ticket'
            }
            onClick={() => onToggleApprovalSingle(data)}
          >
            {data.approval_flag
              ? APPROVED_STATUS.approved.name
              : APPROVED_STATUS.unapproved.name}
          </button>
        </td>
      </React.Fragment>
    )}
    {/* 協力会社名 */}
    <td className='data-table__cell data-table__cell--xl'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(renderCompanyName(data))}
      >
        <div
          className={`data-table__content ${
            data.spot_company_name ? 'show-shrink' : ''
          }`}
        >
          {renderCompanyNameTableCell(data)}
        </div>
      </Tippy>
    </td>
    {/* 作業内容 */}
    <td className='data-table__cell data-table__cell--min-8'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.work_contents)}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.work_contents}
          </span>
        </div>
      </Tippy>
    </td>
    {/* 作業場所 */}
    <td className='data-table__cell data-table__cell--md data-table__cell--min-8'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.work_area)}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.work_area}
          </span>
        </div>
      </Tippy>
    </td>
    {/* 元請担当者 */}
    <td className='data-table__cell data-table__cell--md'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.manager_user_name)}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.manager_user_name}
          </span>
        </div>
      </Tippy>
    </td>
    {/* {isConferenceMode && (
      <td className='data-table__cell' data-unlink style={{ padding: 0 }}>
        <SchaduleBar
          useStartTime={data.use_start_time}
          useEndTime={data.use_end_time}
          spotFlag={data.spot_flag}
          data={data}
          callback={handleGageUpdate}
          isForeman={isTargetRoleId([USER_ROLES.foreman], userRollId)}
          isGate={false}
          scheduleLimitTimes={scheduleLimitTimes}
          disabledTimes={disabledTimes}
          viewOnlyFlag={viewOnlyFlag}
          isTimeBarReset={isTimeBarReset}
        />
      </td>
    )} */}
    <td data-unlink className='data-table__gage-bg' />
  </tr>
);

/**
 * Tooltip
 * @param data {string}
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/CraneUses.jsx